<template>
  <div class="financeManage-blastList-page">
    <p class="hasBottomLine">强平订单管理</p>
    <div class="header-seach-box">
      <div class="setDatePicker">
        <span class="setPading">强平时间</span>
        <el-date-picker v-model="serchStartTime" value-format="timestamp" type="datetime" placeholder="选择开始时间">
        </el-date-picker>
        <span class="setPading">至</span>
        <el-date-picker v-model="serchEndTime" value-format="timestamp" type="datetime" placeholder="选择结束时间">
        </el-date-picker>
      </div>
    </div>
    <div class="header-seach-box">
      <div class="inputWithSelectBox">
        <el-input
          :placeholder="selectType == '1' ? '请输入强平订单编号' : '请输入关联抵押借贷订单编号'"
          v-model="serchInput"
          class="input-with-select"
        >
          <el-select v-model="selectType" slot="prepend" @change="hanldSelectType()" placeholder="请选择">
            <el-option label="强平订单编号" value="1"></el-option>
            <el-option label="关联抵押借贷订单编号" value="2"></el-option>
          </el-select>
          <el-button slot="append" @click="getPageListInfo()" icon="el-icon-search">搜索 </el-button>
        </el-input>
      </div>
      <!-- <el-button type="success" class="toTransLfet" @click="editBtn({}, 'add')">添加方案</el-button> -->
    </div>

    <div class="table-box">
      <el-table :data="blastListInfo" border style="width: 99.9%">
        <el-table-column prop="id" label="强平订单编号"> </el-table-column>
        <el-table-column prop="orderId" label="关联抵押借贷订单编号"> </el-table-column>
        <!-- <el-table-column prop="borrowCoin" label="抵押资产"> </el-table-column> -->
        <el-table-column prop="price" label="强平指数价格"> </el-table-column>
        <!-- <el-table-column prop="blastRate" label="借贷本金+已产生利息"> </el-table-column> -->

        <el-table-column prop="amount" label="强平还款扣除抵押资产"> </el-table-column>
        <el-table-column prop="unfreezeAmount" label="强平剩余抵押资产"> </el-table-column>

        <el-table-column prop="createTime" label="触发强平2时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | moment}}
          </template>
        </el-table-column>
        <el-table-column label="触发强平类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 2">到期强平</span>
            <span v-else-if="scope.row.type == 3">风险率强平</span>
          </template>
        </el-table-column>
        <el-table-column prop="riskRate" label="订单触发强平时风险率（%）"> </el-table-column>

        <el-table-column prop="maxDay" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" @click="toGoDetailPage(scope.row.orderId)">订单详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="pageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="blastListTotal"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import "../store";
import api from "../api";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "Precept",
  data() {
    return {
      editInfo: {},
      selectType: "1",
      serchInput: "",
      serchStartTime: "",
      serchEndTime: "",
      currentPage: 1,
      pageSize: 7
    };
  },
  computed: {
    ...mapState("FinanceManage", ["blastListInfo", "blastListTotal"])
  },
  methods: {
    ...mapActions("FinanceManage", ["getBlastList"]),
    hanldSelectType() {
      this.serchInput = "";
    },
    sizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    pageChange(val) {
      console.log(`当前页: ${val}`);
      this.getPageListInfo();
    },
    toGoDetailPage(id) {
      this.$router.push("/home/finance/manage/mortgage/orderDetail?id=" + id);
    },

    getPageListInfo() {
      let id = "";
      let orderId = "";
      if (this.selectType == "1") {
        id = this.serchInput;
        orderId = "";
      } else {
        id = "";
        orderId = this.serchInput;
      }

      let postData = {
        endTime: this.serchEndTime,
        startTime: this.serchStartTime,
        id: id,
        orderId: orderId,
        page: this.currentPage,
        size: this.pageSize
      };

      this.getBlastList(postData);
    },

    handleSearch() {}
  },
  created() {
    if (this.$route.query.blastId) {
      this.selectType = "1";
      this.serchInput = this.$route.query.blastId;
    }

    if (this.$route.query.orderId) {
      this.selectType = "2";
      this.serchInput = this.$route.query.orderId;
    }
  },
  mounted() {
    this.getPageListInfo();
  }
};
</script>

<style lang="less">
.financeManage-blastList-page {
  width: 100%;
  height: 500px;
  .hasBottomLine {
    width: 100%;
    padding-bottom: 18px;
    font-size: 18px;
    margin-bottom: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
  }

  .header-seach-box {
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    .inputWithSelectBox {
      width: 700px;
      display: flex;
      .el-input-group__prepend {
        .el-select {
          width: 200px;
        }
      }
      .el-input-group__append {
        background: #409eff;
        color: #ffffff;
      }
    }
    .setDatePicker {
      color: #409eff;
      .setPading {
        padding: 0 15px;
      }
    }
    .toTransLfet {
      margin-left: 30px;
    }

    .setSelect {
      margin-left: 30px;
      .el-select {
        margin-left: 12px;
      }
    }
  }

  .table-box {
    width: 100%;
    overflow: hidden;
    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          text-align: center;
          .cell {
            text-align: center;
          }
        }
      }
      .el-table__body-wrapper {
        .cell {
          text-align: center;
        }
      }
    }
  }

  .footer-box {
    padding: 20px 20px 50px 0px;
  }
  .configItem {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #cccccc;
    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
      display: flex;
      align-items: center;
      .el-button {
        margin-left: 50px;
      }
    }
    .item-action {
      display: flex;
      .desc-box {
        margin-right: 30px;
        .imitateInput {
          min-width: 60px;
          padding: 12px 20px;
          display: inline-block;
          text-align: center;
          border: 1px solid #cccccc;
          margin: 0 12px 0;
        }
      }

      .el-switch.is-disabled {
        opacity: 1;
      }
      .el-switch .is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }

      .el-switch.is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }
    .item-remark {
      color: #ff8839;
      padding: 1px 0 22px 0;
    }
  }
}
</style>
